import { ClipboardList } from 'lucide-react'
import type { TaskRef } from '../types'

interface TaskSourceMarkerProps {
  taskRef: TaskRef
  onClick: (taskId: number) => void
}

/**
 * Maly chip pokazywany przy plikach zrodla 'task' na liscie plikow umowy.
 * Klikniecie otwiera TaskDetailDrawer dla zrodlowego zadania. Pokazuje sama nazwe
 * zadania - ikonka clipboard juz sygnalizuje ze to task.
 */
export function TaskSourceMarker({ taskRef, onClick }: TaskSourceMarkerProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onClick(taskRef.id)
      }}
      className="inline-flex items-center gap-1 rounded bg-sky-100 px-2 py-0.5 text-xs text-sky-800 transition-colors hover:bg-sky-200 max-w-[180px]"
      title={`Z taska: ${taskRef.title}`}
    >
      <ClipboardList className="size-3 flex-shrink-0" />
      <span className="truncate">{taskRef.title}</span>
    </button>
  )
}
